import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionAfterschoolComponent } from './question-afterschool.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
  imports: [
    QuestionModule,
    NgxChartsModule,
   ],
  declarations:[QuestionAfterschoolComponent],
  exports:[QuestionAfterschoolComponent],
})
export class QuestionAfterschoolModule { }

